// extracted by mini-css-extract-plugin
module.exports = {"container":"Alert_container__1GidY","hide":"Alert_hide__1chrC"};